import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { NavLink } from 'redux-first-router-link';

export const CuiNavigationButton = ({
  children,
  className,
  path,
  type,
  index,
  ...rest
}) => {
  const classes = classNames('cuiNavigationButton', className, {
    'cuiNavigationButton--section': type === 'section',
    'cuiNavigationButton--group': type === 'group',
  });

  let humanizedIndex;

  if (typeof index === 'number') {
    humanizedIndex = `${index}. `;
  }

  return (
    <NavLink
      className={classes}
      activeClassName="cuiNavigationButton-isSelected"
      to={path}
      isActive={(match, location) => location.pathname === path}
      {...rest}
    >
      {humanizedIndex}
      {children}
    </NavLink>
  );
};

CuiNavigationButton.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  path: PropTypes.string.isRequired,
  type: PropTypes.string,
  index: PropTypes.number,
};

CuiNavigationButton.defaultProps = {
  children: undefined,
  className: undefined,
  type: undefined,
  index: undefined,
};



// WEBPACK FOOTER //
// ./ui/components/sideBar/navigation/NavigationButton.js